import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { CommonUtilService } from "../services/common-util/common-util.service";
import { VisitComponent } from "../print-monitor/visited/visit.component";

@Component({
selector:'manage-visit',
standalone:true,
imports:[CommonModule],
template:`
<div class="d-flex align-items-center btn-gap flex-wrap">
    <button class="dp-secondary-btn btn-padding" [disabled]="rowData.isVisitedByMe===1"
    (click)="onCellClick('Add details')" [class.disabled]="rowData.isVisitedByMe===1">
        <span>Add visit</span>
        @if(rowData.isVisitedByMe===1){
            <div class="tick" style="background:var(--disc-tick)"></div>
        }
        <div class="heart-div" style="background:var(--location)"></div>
    </button>       
    <button class="dp-secondary-btn btn-padding" [disabled]="rowData.visit_count===0"
    (click)="onCellClick('Visit history')" [class.disabled]="rowData.visit_count===0">
        <span>Visit history</span>
        @if(rowData.visit_count!==0){
            <div class="visit-count">{{rowData.visit_count}}</div>
        }
        <div class="heart-div" style="background:var(--visit-history)"></div>
    </button>
    @if(rowData.canDelete || rowData.canDelete == undefined){
    <button class="dp-secondary-btn  delete-btn" (click)="onCellClick('delete')">
        <img src='../../assets/images/delete-cell.svg' />
    </button>
    }
<div>
`,//;$event.stopPropagation()
styles:[`
        .heart-div{
            height:24px;
            width:24px;
            background-repeat: no-repeat !important;
            background-size: contain !important;
        }
        .tick{
            height: 14px;width: 14px;
            position:absolute;top: 6px;right: 5px;
        }
        .visit-count{
            height: 16px;width: 16px;
            background-color: var(--text-secondary);
            outline: 3px solid var(--bg-primary);border-radius: 999px;
            font: 800 14px / 16px var(--manrope);color: var(--bg-primary);
            position: absolute;left: 22px;top: 6px;
        }
        .btn-padding {
            position: relative;
            padding: 10px 8px 11px 8px;

            span{
                display: none;z-index: 9;
                position: absolute;top: -28px;left: -26px;
                height: fit-content;width: max-content;
                padding: 4px;border-radius: 4px;
                background-color: var(--text-tertiary);
                font: 400 16px / 18px var(--manrope);color: var(--bg-secondary);
            }
            &:hover span{
                display: block;
            }
        }
        .disabled{
            border: none;
            background-color: var(--input-focus);
        }
        .btn-gap {
            gap: 12px;
        }
        .delete-btn {
            position: relative;
            padding: 11px 10px 15px;
        }
    `]
})
export class ManageVisitCellComponent{
    @Input() rowData:any;
    @Output() cellClick:EventEmitter<any>=new EventEmitter();

    onCellClick(Type:string) {
        if(Type==='delete')
            this.cellClick.emit(this.rowData);
        else
            this.cellClick.emit({rowData:this.rowData,type:Type});
    }
}